import {
  Form,
  useActionData,
  useNavigate,
  useLoaderData,
} from "react-router-dom";
import useInfoSnackbar from "../../lib/bandung/hooks/useInfoSnackbar";
import React, { useEffect } from "react";
import { Box, Button, MenuItem, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

export const EventForm = ({ event }) => {
  const { conversations } = useLoaderData();
  const isCreate = event === null;
  const actionData = useActionData();
  const infoSnackbar = useInfoSnackbar(2000, "bottom", "right");
  const navigate = useNavigate();
  const handleCancel = () => navigate("../", { replace: true });

  useEffect(() => {
    if (actionData) {
      if (actionData.code === "SUCCESS") {
        infoSnackbar.alertSuccess(actionData.message);
        navigate("../", { replace: true });
      } else {
        infoSnackbar.alertError(actionData.message);
      }
    }
  }, [actionData]);

  return (
    <div className="aboutus-wrapper w-full">
      <Form method={"post"} className="container-x mx-auto py-10">
        <input
          name="eventEntityId"
          readOnly
          hidden
          value={event?.eventEntityId}
        />
        <input
          name="oldShortDescription"
          readOnly
          hidden
          value={encodeURIComponent(event?.shortDescription)}
        />
        <div>
          <TextField
            id="label"
            name="label"
            label="Label"
            fullWidth
            margin="normal"
            defaultValue={event?.label}
            required
          />
          <div className="mb-4">
            <TextField
              id="eventTypeEntityId"
              name="eventTypeEntityId"
              label="Select Event Type"
              fullWidth
              select
              margin="normal"
              defaultValue={event?.eventTypeEntityId}
              required
            >
              {conversations.map((conversation) => (
                <MenuItem
                  key={conversation.conversationEntityId}
                  value={conversation.conversationEntityId}
                >
                  {conversation.label}
                </MenuItem>
              ))}
            </TextField>
          </div>
          <Box component="div" sx={{ my: 1.5 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slotProps={{
                  textField: {
                    required: true,
                    name: "startDate",
                  },
                }}
                label="Start Date"
                disablePast={true}
                sx={{ width: "49.3% ", mr: 2, mt: 2 }}
                format={"MM/DD/YYYY"}
                defaultValue={event ? dayjs(event?.startDate) : null}
              />
              <TimePicker
                slotProps={{
                  textField: {
                    required: true,
                    name: "startTime",
                  },
                }}
                label="Start Time"
                ampm={false}
                sx={{ width: "49.3%", mt: 2 }}
                defaultValue={event ? dayjs(event?.startTime, "HH:mm") : null}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slotProps={{
                  textField: {
                    required: true,
                    name: "endDate",
                  },
                }}
                label="End Date"
                disablePast={true}
                sx={{ width: "49.3% ", mr: 2, mt: 2 }}
                defaultValue={event ? dayjs(event?.endDate) : null}
              />
              <TimePicker
                slotProps={{
                  textField: {
                    required: true,
                    name: "endTime",
                  },
                }}
                label="End Time"
                ampm={false}
                sx={{ width: "49.3%", mt: 2 }}
                defaultValue={event ? dayjs(event?.endTime, "HH:mm") : null}
              />
            </LocalizationProvider>
          </Box>
          <TextField
            id="shortDescription"
            name="shortDescription"
            label="Short Description"
            fullWidth
            margin="normal"
            required
            defaultValue={event?.shortDescription}
          />
          <Button
            sx={{ my: 2, mx: 2 }}
            variant="contained"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            sx={{ my: 2, mx: "auto" }}
            variant="contained"
            type={"submit"}
          >
            {isCreate ? "Create" : "Save"}
          </Button>
        </div>
      </Form>
    </div>
  );
};
